/**
 * Pin an OAuth authorization URL to a specific account so an already-signed-in user skips the
 * account chooser and lands straight on the scope-consent page (used by the read-scope reconnect,
 * which upgrades one known mailbox rather than connecting an arbitrary account).
 *
 * @param includeGrantedScopes Google-only: keep previously-granted scopes (e.g. send) when adding read.
 */
export const pinOAuthAccount = (authUrl: string, loginHint?: string, includeGrantedScopes = false): string => {
    if (!loginHint) return authUrl
    try {
        const url = new URL(authUrl)
        url.searchParams.set('login_hint', loginHint)
        if (includeGrantedScopes) url.searchParams.set('include_granted_scopes', 'true')
        return url.toString()
    } catch {
        return authUrl
    }
}
